import { createContext } from 'react';

import {
  DEFAULT_ANNOTATIONS_DIMENSIONS,
  DEFAULT_LABELS_OFFSET,
  DEFAULT_LABELS_WIDTH,
  type AnnotationsDimensions,
} from '../constants.js';

interface AnnotationsContextProps {
  showLabels: boolean;
  labelsWidth: number;
  trackWidth: number;
  dimensions: AnnotationsDimensions;
  showMarkerContent: boolean;
  /**
   * Draws a separator line below the last (bottom-most) track, closing off the
   * markers band. Used by charts where the annotations area is not directly
   * adjacent to the plot (e.g. an XY chart with a top axis), so the plot border
   * cannot serve as the separator.
   */
  outerBottomLine?: boolean;
}

export const AnnotationsConfigContext = createContext<AnnotationsContextProps>({
  showLabels: true,
  labelsWidth: DEFAULT_LABELS_OFFSET + DEFAULT_LABELS_WIDTH,
  trackWidth: 0,
  dimensions: DEFAULT_ANNOTATIONS_DIMENSIONS,
  showMarkerContent: true,
  outerBottomLine: false,
});

AnnotationsConfigContext['displayName'] = 'AnnotationsConfig.Context';
